import surveyCampaignManagement from '@/translations/fr/components/surveyCampaign/surveyCampaignManagement';
import surveyCampaignHeader from '@/translations/fr/components/surveyCampaign/surveyCampaignHeader';
import surveyCampaignEligiblePatients from '@/translations/fr/components/surveyCampaign/surveyCampaignEligiblePatients';
import surveyCampaignStats from '@/translations/fr/components/surveyCampaign/surveyCampaignStats';
import surveyCampaignReport from '@/translations/fr/components/surveyCampaign/surveyCampaignReport';
import surveyCampaignAccessMasterReportList from '@/translations/fr/components/surveyCampaign/surveyCampaignAccessMasterReportList';

export default {
	surveyCampaignManagement,
	surveyCampaignHeader,
	surveyCampaignEligiblePatients,
	surveyCampaignStats,
	surveyCampaignReport,
	surveyCampaignAccessMasterReportList
};
